function SMRoomMarker(room, className, map, args) {
	this.room = room;	
  this.latlng = new google.maps.LatLng(
    room.space.latitude,
    room.space.longitude
  );
	this.args = args;	
	this.className = className;	
	this.setMap(map);	
}
export default SMRoomMarker;


// WEBPACK FOOTER //
// ./app/javascript/lib/SMRoomMarker.js